import React from 'react';
import {Navigate} from "react-router-dom";
export function Logout() {
    localStorage.removeItem("licenseToken");
    return <Navigate to={"/login"}/>
 }
